<script>
  import { onMount } from "svelte";
  import { localeOrderBy } from "../../mjnUtils";

  let { http, toastr, goTo, id } = $props();

  let members = $state([]);
  let projekt = $state(null);
  let projektOrig = $state(null);

  onMount(() => {
    http.get("/api/czlonek.php").then((response) => {
      members = response.data.records;
      if (id == -1) {
        projekt = {};
        projektOrig = {};
      } else {
        http.get("/api/projekt.php?id=" + id).then((response2) => {
          projekt = response2.data.records[0];
          projektOrig = { ...projekt };
        });
      }
    });
  });

  let sortedMembers = $derived(localeOrderBy(members, "nazwisko", false));

  function save() {
    if (id == -1) {
      http.post("/api/projekt.php", projekt).then(
        (response) => {
          if (response.data.status == 200) {
            toastr.info("Dodano nowy projekt " + projekt.nazwa);
            const inserted = response.data.records[0];
            goTo("project-detail", { id: inserted.idpr });
          } else {
            toastr.error("Błąd: " + response.data.message);
          }
        },
        () => {
          toastr.error("Błąd połączenia");
        },
      );
    } else {
      http.put("/api/projekt.php", projekt).then(
        (response) => {
          if (response.data.status == 200) {
            toastr.info("Zmodyfikowano projekt " + projekt.nazwa);
            goTo("project-detail", { id: projekt.idpr });
          } else {
            toastr.error("Błąd: " + response.data.message);
          }
        },
        () => {
          toastr.error("Błąd połączenia");
        },
      );
    }
  }

  function reset() {
    projekt = { ...projektOrig };
  }
</script>

{#if projekt}
<h3>Edycja: {projekt.nazwa}</h3>

<form class="form form-inline" onsubmit={(e) => { e.preventDefault(); save(); }} role="form">
<table class="table table-condensed table-hover table-striped">
    <tbody>
      <tr>
        <td>
        Krótka, unikalna nazwa:
        </td>
        <td>
        <input type="text" class="form-control input-sm" placeholder="Unikalna nazwa" bind:value={projekt.nazwa} id="nazwa" size="50" required>
        </td>
      </tr>
      <tr>
        <td>
        Pełna nazwa:
        </td>
        <td>
        <input type="text" class="form-control input-sm" placeholder="Pełna nazwa" bind:value={projekt.nazwa_dl} id="nazwa_dl" size="50" required>
        </td>
      </tr>
      <tr>
        <td>
        Data początkowa:
        </td>
        <td>
        <input type="text" class="form-control input-sm" placeholder="RRRR-MM-DD" bind:value={projekt.data_od} id="data_od" size="50">
        </td>
      </tr>
      <tr>
        <td>
        Data końcowa:
        </td>
        <td>
        <input type="text" class="form-control input-sm" placeholder="RRRR-MM-DD" bind:value={projekt.data_do} id="data_do" size="50">
        </td>
      </tr>
	  <tr>
        <td>
        Kwota:
        </td>
        <td>
        <input type="text" class="form-control input-sm" placeholder="Kwota" bind:value={projekt.kwota} id="kwota" size="50">
        </td>
      </tr>
      <tr>
        <td>
        Waluta:
        </td>
        <td>
        <input type="text" class="form-control input-sm" placeholder="PLN/USD/EUR itp." bind:value={projekt.waluta} id="waluta" size="50">
        </td>
      </tr>
      <tr>
        <td>
        Osoba koordynująca:
        </td>
        <td>
            <select class="form-control input-sm" name="osoba" bind:value={projekt.koord} required>
              {#each sortedMembers as option}<option value={option.idcz}>{option.imie} {option.nazwisko}</option>{/each}
            </select>
        </td>
      </tr>
      <tr>
        <td>
        Dodatkowe informacje:
        </td>
        <td>
        <textarea class="form-control input-sm" name="info" id="info" bind:value={projekt.info} rows="8" cols="50"></textarea>
        </td>
      </tr>
    </tbody>
</table>

<button class="btn btn-info" type="submit">Zapisz</button>
<button class="btn btn-info" type="button" onclick={reset}>Przywróć początkowe</button>
</form>
{/if}
